import React, { ReactNode, useState } from 'react'
import { useAsync } from 'react-use'

import { FeatureFlagContext } from 'components'
import { useAccountContext } from 'components/contexts/AccountContext'
import { Feature } from 'types/Feature'
import { fetchFeatures } from 'utils'

interface FeatureFlagProviderProps {
  children?: ReactNode
}

const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps): JSX.Element => {
  const [featuresList, setfeaturesList] = useState<Feature[]>([])
  const accountContext = useAccountContext()

  useAsync(async () => {
    if (accountContext.orgId) {
      const featuresList = await fetchFeatures(accountContext.orgId)
      setfeaturesList(featuresList)
    } else {
      setfeaturesList([])
    }
  }, [accountContext.orgId])

  return <FeatureFlagContext.Provider value={featuresList}>{children}</FeatureFlagContext.Provider>
}

export default FeatureFlagProvider
